var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1"},React.createElement("g",{"stroke":"#142B6F","strokeWidth":"2"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M14,14 L2,2 L14,14 Z M14,2 L2,14 L14,2 Z","transform":"translate(-284.000000, -22.000000) translate(284.000000, 22.000000)"}))))));
}

IconClose.defaultProps = {"width":"16","height":"16","version":"1.1","viewBox":"0 0 16 16"};

module.exports = IconClose;

IconClose.default = IconClose;
